var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12C19.5 7.58172 15.9183 4 11.5 4C7.08172 4 3.5 7.58172 3.5 12C3.5 16.4183 7.08172 20 11.5 20C15.9183 20 19.5 16.4183 19.5 12Z",
    fill: "#23FFB0",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 7.85786 15.6421 4.5 11.5 4.5C7.35786 4.5 4 7.85786 4 12C4 16.1421 7.35786 19.5 11.5 19.5C15.6421 19.5 19 16.1421 19 12Z",
    stroke: "#23FFB0",
    strokeOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12C8.36599 12 11.5 15.1339 11.5 19C11.5 15.1339 14.634 12 18.5 12C14.634 12 11.5 8.86615 11.5 5C11.5 8.86615 8.36599 12 4.5 12Z",
    fill: "#23FFB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7C16.1569 7 17.5 8.34308 17.5 10C17.5 8.34308 18.8431 7 20.5 7C18.8431 7 17.5 5.65692 17.5 4C17.5 5.65692 16.1569 7 14.5 7Z",
    fill: "#23FFB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/Rewards.d445e1a825a8e237f4e0eb86b3d5decf.svg";
export { ForwardRef as ReactComponent };